import React from 'react';
import background from '../../assets/phytoplankton.png';
import ReusableInfoCard from '../../components/ReusableInfoCard/ReusableInfoCard';

class InfoPhytoplankton extends React.Component {
  render () { 
   return(
  
  <ReusableInfoCard             
    
        tag="OCEANS"
        subtag="FOOD WEB"
        description="Phytoplankton"
        paragraph="Phytoplankton are microscopic marine algae. They are the basis of the marine food web, providing nutrients for a wide range of sea creatures including whales, shrimp, snails, and jellyfish."
        background={background}
     />
  
  );
 }
}   



export default InfoPhytoplankton;